import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'basic'>('pro');
  return <section id="pricing" className="py-12 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Precios y planes" data-id="element-202">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-203">
        {/* Pricing Selector */}
        <FadeIn data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8" data-id="element-205">
            ELEGÍ TU <span className="text-gold" data-id="element-206">KIT DE RESCATE</span>
          </h2>
        </FadeIn>

        <div id="elegir-plan" className="max-w-2xl mx-auto mb-12" role="radiogroup" aria-label="Seleccionar plan" data-id="element-207">
          {/* Basic Plan Option */}
          <FadeIn delay={0.1} data-id="element-208">
            <button onClick={() => setSelectedPlan('basic')} role="radio" aria-checked={selectedPlan === 'basic'} aria-label="Kit Adulto de Rescate — $19.990 ARS" className={`w-full text-left rounded-2xl p-6 mb-4 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'basic' ? 'border-gold shadow-[0_0_25px_rgba(212,168,67,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-209">
              <div className="flex items-start gap-4" data-id="element-210">
                {/* Radio */}
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'basic' ? 'border-gold' : 'border-gray-500'}`} data-id="element-211">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-212"></div>}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-213">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-214">
                    <div data-id="element-215">
                      <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-216">
                        <span data-id="element-217">🩹</span> KIT ADULTO DE RESCATE
                      </h3>
                      <p className="text-gray-400 text-sm mb-3" data-id="element-218">
                        6 Módulos + 4 Bonos
                      </p>
                      <div className="bg-surfaceLight/50 px-3 py-2 rounded-lg border border-white/5 text-xs text-gray-300 inline-block" data-id="element-219">
                        <span className="font-semibold text-white" data-id="element-220">
                          Ideal para:
                        </span>{' '}
                        Padres que quieren herramientas tácticas para todas las
                        crisis de la adolescencia
                      </div>
                    </div>
                    <div className="sm:text-right shrink-0" data-id="element-221">
                      <span className="text-gray-500 line-through text-sm block" data-id="element-222">
                        $54.000
                      </span>
                      <span className="text-3xl font-bold text-white font-heading" data-id="element-223">
                        $19.990
                      </span>
                      <span className="text-sm text-gray-400 ml-1" data-id="element-224">ARS</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </FadeIn>

          {/* Pro Plan Option */}
          <FadeIn delay={0.2} data-id="element-225">
            <div className="relative" data-id="element-226">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-227">
                <span className="bg-gold text-background font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-228">
                  Más Elegido ⭐
                </span>
              </div>
              <button onClick={() => setSelectedPlan('pro')} role="radio" aria-checked={selectedPlan === 'pro'} aria-label="Kit Adulto de Rescate + Deck Táctico — $27.990 ARS" className={`w-full text-left rounded-2xl p-6 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'pro' ? 'border-gold shadow-[0_0_25px_rgba(212,168,67,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-229">
                <div className="flex items-start gap-4" data-id="element-230">
                  {/* Radio */}
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'pro' ? 'border-gold' : 'border-gray-500'}`} data-id="element-231">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-232"></div>}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-233">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-234">
                      <div data-id="element-235">
                        <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-236">
                          <span data-id="element-237">🏆</span> KIT ADULTO DE RESCATE + DECK TÁCTICO{' '}
                          <span className="text-yellow" data-id="element-238">⭐</span>
                        </h3>
                        <p className="text-gold text-sm font-medium mb-3" data-id="element-239">
                          6 Módulos + 4 Bonos + 50 Tarjetas de Respuesta Rápida
                        </p>
                        <div className="bg-gold/5 px-3 py-2 rounded-lg border border-gold/20 text-xs text-gray-300 inline-block" data-id="element-240">
                          <span className="font-semibold text-white" data-id="element-241">
                            Ideal para:
                          </span>{' '}
                          Padres que quieren tener la respuesta exacta para cada
                          situación sin tener que pensar en el momento
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-242">
                        <span className="text-gray-500 line-through text-sm block" data-id="element-243">
                          $72.000
                        </span>
                        <span className="text-3xl font-bold text-gold font-heading" data-id="element-244">
                          $27.990
                        </span>
                        <span className="text-sm text-gold/70 ml-1" data-id="element-245">ARS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          {/* Single CTA Button */}
          <FadeIn delay={0.3} data-id="element-246">
            <a href={selectedPlan === 'pro' ? 'https://fegion.shop/cart/46824994341003:1' : 'https://fegion.shop/cart/46824945516683:1'} className="block w-full mt-6 py-5 text-center rounded-2xl font-bold text-background bg-gold hover:bg-gold/90 transition-colors shadow-lg uppercase tracking-wider text-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" aria-label={selectedPlan === 'pro' ? 'Comprar Kit Completo + Deck Táctico por $27.990' : 'Comprar Kit Adulto de Rescate por $19.990'} data-id="element-247">
              {selectedPlan === 'pro' ? '→ QUIERO EL KIT COMPLETO + DECK TÁCTICO' : '→ QUIERO MI KIT AHORA'}
            </a>
          </FadeIn>
        </div>

        {/* Comparison Table */}
        <FadeIn delay={0.2} data-id="element-248">
          <div className="max-w-4xl mx-auto mb-12" data-id="element-249">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-250">
              🕊️ ¿QUÉ AGREGA EL DECK TÁCTICO?
            </h3>
            <p className="text-gray-400 text-center mb-6" data-id="element-251">
              El sistema completo para nunca más quedarte sin saber qué decir
            </p>
            <p className="text-sm text-gray-400 mb-2 md:hidden text-center" data-id="element-252">
              ← Scroll to see full table →
            </p>
            <div className="overflow-x-auto pb-4" data-id="element-253">
              <table className="w-full min-w-[600px] text-left border-collapse" data-id="element-254">
                <thead data-id="element-255">
                  <tr data-id="element-256">
                    <th className="p-4 border-b border-white/10 text-gray-300 font-semibold bg-surfaceLight/30 rounded-tl-xl" data-id="element-257">
                      Situación en casa
                    </th>
                    <th className="p-4 border-b border-white/10 text-red-400 font-semibold bg-red-500/5" data-id="element-258">
                      ❌ Sin Deck
                    </th>
                    <th className="p-4 border-b border-white/10 text-gold font-semibold bg-gold/5 rounded-tr-xl" data-id="element-259">
                      ✅ Con Deck
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm md:text-base" data-id="element-260">
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-261">
                    <td className="p-4 text-gray-300" data-id="element-262">
                      Tu hijo explota y no sabés qué decir
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-263">
                      Improvisás y generalmente empeora
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-264">
                      Tarjeta ROJA. Protocolo exacto. 60 segundos.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-265">
                    <td className="p-4 text-gray-300" data-id="element-266">
                      Está ansioso antes de un examen
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-267">
                      Le decís "calmate" y se cierra más
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-268">
                      Tarjeta AZUL. Técnica física inmediata.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-269">
                    <td className="p-4 text-gray-300" data-id="element-270">
                      Silencio total, no habla hace días
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-271">
                      No sabés si presionar o esperar
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-272">
                      Tarjeta BLANCA. Apertura sin invasión.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-273">
                    <td className="p-4 text-gray-300" data-id="element-274">
                      Baja autoestima, se destruye solo/a
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-275">
                      Decís cosas que no ayudan sin querer
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-276">
                      Tarjeta DORADA. Frase de validación exacta.
                    </td>
                  </tr>
                  <tr className="hover:bg-white/5 transition-colors" data-id="element-277">
                    <td className="p-4 text-gray-300 rounded-bl-xl" data-id="element-278">
                      Después de una pelea fuerte
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-279">
                      El silencio se vuelve permanente
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium rounded-br-xl" data-id="element-280">
                      Tarjeta VERDE. Protocolo de reparación.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </FadeIn>

        {/* Kit Includes */}
        <FadeIn delay={0.3} data-id="element-281">
          <div className="max-w-4xl mx-auto mb-12 bg-surfaceLight/30 rounded-3xl p-8 border border-white/5" data-id="element-282">
            <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-283">
              ✅ EL DECK INCLUYE:
            </h3>
            <p className="text-gray-300 text-center mb-6 font-medium" data-id="element-284">
              50 Tarjetas de Respuesta Rápida organizadas por color:
            </p>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-285">
              {['🔴 Tarjetas Rojas — Crisis y explosiones', '🟡 Tarjetas Amarillas — Tensión y señales de alerta', '🔵 Tarjetas Azules — Ansiedad y pánico', '🟢 Tarjetas Verdes — Reconexión y reparación', '⚪ Tarjetas Blancas — Silencio y cierre emocional', '🟤 Tarjetas Doradas — Autoestima y validación'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-background/50 p-4 rounded-xl border border-white/5" data-id="element-286">
                  <span className="text-gray-300" data-id="element-287">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <FadeIn delay={0.4} data-id="element-288">
          <div className="max-w-5xl mx-auto mb-12" data-id="element-289">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center" data-id="element-290">
              ❤️ MÁS FAMILIAS QUE YA LO TIENEN
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-291">
              {[{
              name: 'Cecilia R.',
              loc: '📍 Mendoza',
              plan: 'Kit + Deck Táctico',
              text: 'El Deck me salvó la vida. Mi hija estaba en plena crisis de ansiedad y yo tenía la tarjeta azul en la mano. Lo hice paso a paso y funcionó. Lloré de alivio.'
            }, {
              name: 'Roberto M.',
              loc: '📍 Buenos Aires',
              plan: 'Kit Adulto de Rescate',
              text: 'Llevaba 2 años sin poder hablar más de 5 minutos con mi hijo sin explotar. El módulo 1 me cambió la cabeza.'
            }, {
              name: 'Sofía C.',
              loc: '📍 La Plata',
              plan: 'Kit + Deck Táctico',
              text: 'Mi hijo de 16 años empezó a usar el Diario Silencioso por su cuenta. Sin que yo se lo pidiera. No lo podía creer.'
            }, {
              name: 'Pablo A.',
              loc: '📍 Neuquén',
              plan: 'Kit Adulto de Rescate',
              text: 'El Protocolo Sin Palabras fue un antes y un después. Ahora tenemos un sistema para cuando ninguno puede hablar. La tensión en casa bajó un 80%.'
            }].map((t, i) => <div key={i} className="bg-surfaceLight p-6 rounded-2xl border border-white/5" data-id="element-292">
                  <div className="flex gap-1 mb-3" data-id="element-293">
                    {[...Array(5)].map((_, j) => <span key={j} className="text-yellow text-sm" data-id="element-294">
                        ★
                      </span>)}
                  </div>
                  <p className="text-gray-300 mb-4 italic" data-id="element-295">"{t.text}"</p>
                  <div className="text-sm" data-id="element-296">
                    <span className="font-bold text-white" data-id="element-297">{t.name}</span>
                    <span className="text-gray-500 mx-2" data-id="element-298">|</span>
                    <span className="text-gray-400" data-id="element-299">{t.loc}</span>
                    <span className="text-gray-500 mx-2" data-id="element-300">|</span>
                    <span className="text-gold text-xs" data-id="element-301">{t.plan}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Guarantee */}
        <FadeIn delay={0.5} data-id="element-302">
          <div className="max-w-3xl mx-auto bg-surfaceLight/50 rounded-3xl p-8 md:p-12 border border-white/5 text-center" data-id="element-303">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/5 mb-6 text-4xl" data-id="element-304">
              🛡️
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-305">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>
            <p className="text-gray-300 text-lg mb-6" data-id="element-306">
              Abrís el kit. Lo usás con tu hijo/a. Si en 7 días no es lo que
              esperabas:
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6 text-white font-medium" data-id="element-307">
              <div className="flex items-center justify-center gap-2" data-id="element-308">
                <span className="text-green-400" data-id="element-309">✅</span> devolución del 100%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-310">
                <span className="text-green-400" data-id="element-311">✅</span> sin formularios, sin
                drama.
              </div>
            </div>
            <div className="inline-block bg-background px-4 py-2 rounded-lg border border-white/10 text-sm text-gray-400" data-id="element-312">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </FadeIn>

        {/* FAQ */}
        <FadeIn delay={0.6} data-id="element-313">
          <div className="max-w-3xl mx-auto mt-12" data-id="element-314">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-315">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h3>
            <div className="space-y-4" role="list" data-id="element-316">
              {[{
              q: '¿Sirve si mi hijo/a es muy cerrado/a y nunca quiere hacer nada?',
              a: 'Sí. La mayoría de las herramientas están diseñadas para adolescentes que rechazan la ayuda directa. No requieren que el adolescente coopere activamente para funcionar.'
            }, {
              q: '¿Cómo recibo el material?',
              a: 'Al confirmar tu pago recibís un email con acceso inmediato a todo el contenido. En menos de 5 minutos tenés todo disponible.'
            }, {
              q: '¿Qué lo diferencia de los libros de crianza que ya leí?',
              a: 'No es un libro de teoría. Es un sistema de herramientas tácticas listas para usar en el momento exacto de la crisis. Nada de entiende la neurociencia adolescente. Todo de hacé esto ahora.'
            }, {
              q: '¿Tengo que ser psicólogo para usarlo?',
              a: 'No. Las instrucciones están escritas en español claro, directo y sin tecnicismos. Si podés leer esto, podés aplicarlo.'
            }, {
              q: '¿Sirve para adolescentes con diagnóstico (TDAH, ansiedad clínica, etc.)?',
              a: 'Las herramientas son complementarias al acompañamiento profesional. No reemplazan la terapia pero sí potencian lo que el profesional ya está haciendo.'
            }].map((faq, i) => <div key={i} className="bg-surfaceLight border border-white/5 rounded-xl overflow-hidden" role="listitem" data-id="element-317">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-gold" aria-expanded={openFaq === i} aria-controls={`faq-answer-${i}`} data-id="element-318">
                    <span className="font-medium text-white pr-4" data-id="element-319">{faq.q}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-320" />
                  </button>
                  {openFaq === i && <div id={`faq-answer-${i}`} className="px-6 pb-4 text-gray-400" role="region" aria-label={faq.q} data-id="element-321">
                      {faq.a}
                    </div>}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}